import { ICalendarEvent } from "motw_core/Calendar/ICalendarEvent";
import * as React from "react";
import Hyperlink from "source/app/presentation/Shared/Link/Hyperlink";
import { StyleClassAuto } from "source/app/presentation/Shared/Styles/Auto/StyleClassAuto";
import { ICalendarEventEditorState } from "./ICalendarEventEditorState";
import { SaveCalendarEditorStateAndCloseAsync } from "./SaveCalendarEditorStateAndCloseAsync";

export function ShowGoalName({
    goalName,
    state,
    SaveAction,
}: {
    goalName: string;
    state: ICalendarEventEditorState;
    SaveAction: (withEventData?: ICalendarEvent) => Promise<void>;
}) {
    const background = state.matchingGoals.length === 1 ? `green` : `dimgray`;

    return (
        <Hyperlink
            classes={StyleClassAuto({
                margin: "5px",
                background,
                borderRadius: "5px",
                padding: "5px",
                display: `block`,
            })}
            whenClicked={async () =>
                await SaveCalendarEditorStateAndCloseAsync(
                    state,
                    goalName,
                    SaveAction
                )
            }
        >
            {goalName}
        </Hyperlink>
    );
}
